import { Card } from "primereact/card";
import { ProgressSpinner } from "primereact/progressspinner";
import { Suspense } from "react";

import { useLazyLoadQuery } from "react-relay";
import { useParams } from "react-router-dom";
import { useTranslation } from "@i18n/hooks";
import { type externalLicenseEditScreen_ExternalLicenseQuery } from "@relay/externalLicenseEditScreen_ExternalLicenseQuery.graphql";
import { QUERY } from "./external-license-edit.graphql";
import { EditExternalLicenseForm } from "./parts/edit-external-license-form/edit-external-license-form.component";
import { NoAccess } from "../../components/no-access";
import { useHasPermissions } from "../../hooks/use-has-permissions";

export const ExternalLicenseEditScreen = () => {
	const { t } = useTranslation("common");
	const { [`externalLicenseId`]: externalLicenseId } = useParams();

	const query = useLazyLoadQuery<externalLicenseEditScreen_ExternalLicenseQuery>(QUERY, {
		id: externalLicenseId!,
		skip: !externalLicenseId,
	});

	const canReadAndModify = useHasPermissions([
		"UserInAccountPermission_ExternalLicenseAdmin_Read",
		"UserInAccountPermission_ExternalLicenseAdmin_Modify",
	]);

	if (!canReadAndModify) {
		return <NoAccess />;
	}

	return query.node ? (
		<Suspense fallback={<ProgressSpinner />}>
			<div className="p-4">
				<Card>
					<h2 className="mb-3 text-center">{t("externalLicenses.title")}</h2>
					<EditExternalLicenseForm entityRef={query?.node} />
				</Card>
			</div>
		</Suspense>
	) : (
		<h4>{t("externalLicenses.loadError")}</h4>
	);
};
